import React from 'react';

const Preview = ({ src, name, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4" 
      onClick={onClose} // Close the modal on background click
    >
      {/* Stop propagation to prevent closing when clicking on the content */}
      <div 
        className="relative max-w-2xl w-full mx-auto" 
        onClick={(e) => e.stopPropagation()} 
      >
        {/* Close button container */}
        <div className="fixed top-4 right-4">
        <button 
            onClick={onClose}
            aria-label="Close preview"
          >
            <svg className="w-6 h-6" fill="none" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor" color='white'>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Image container */}
        <div className="rounded overflow-hidden">
          <div className="relative aspect-video">
            <img 
              src={src} 
              alt={name}
              className="w-full h-full object-contain"
            />
          </div>

          {/* Name displayed at the bottom and centered */}
          <div className="text-center mt-4">
            <p className="text-white font-medium">{name}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
